<template>
  <slot
    :is-empty-index="isEmptyIndex"
    :is-searching="isSearching"
  />
</template>

<script lang="ts" setup>
import { computed, inject, onMounted, onBeforeUnmount, ref } from 'vue'

import { SearchResultsState } from '@js/types/search/SearchResultsState'

defineOptions({
  name: 'BaseSearchResultsState',
})

type SearchIndex = {
  getResults: () => { nbHits: number } | null
  getHelper: () => { state?: { query?: string } } | null
}

type InstantSearchInstance = {
  mainIndex?: SearchIndex
  addListener: (event: string, listener: () => void) => void
  removeListener: (event: string, listener: () => void) => void
}

const instantSearchInstance = inject<InstantSearchInstance | undefined>('$_ais_instantSearchInstance', undefined)
const getParentIndex = inject<(() => SearchIndex) | undefined>('$_ais_getParentIndex', undefined)

const state = ref<SearchResultsState>({ nbHits: null, query: '' })

const readState = () => {
  const index = getParentIndex ? getParentIndex() : instantSearchInstance?.mainIndex
  const results = index?.getResults()

  state.value = {
    nbHits: results ? results.nbHits : null,
    query: index?.getHelper()?.state?.query ?? '',
  }
}

const isSearching = computed(() => Boolean(state.value.query))

// Null nbHits means the first response hasn't landed (or failed), so assume there is
// something to show rather than hiding the search behind an empty state.
const isEmptyIndex = computed(() => state.value.nbHits === 0 && !isSearching.value)

onMounted(() => {
  instantSearchInstance?.addListener('render', readState)
  readState()
})

onBeforeUnmount(() => {
  instantSearchInstance?.removeListener('render', readState)
})
</script>
